import { Routes } from '@angular/router'
import { hasNoConnectionGuard } from '@app-guards/has-no-connection.guard'
import { isConfiguredGuard } from '@app-guards/is-configured.guard'
import { isNotConfiguredGuard } from '@app-guards/is-not-configured.guard'
import { NoConnectionComponent } from '@app-pages/no-connection/no-connection.component'
import { TestComponent } from '@app-pages/test/test.component'
import { FormPageComponent } from './pages/form-page/form-page.component'
import { OnboardingPageComponent } from './pages/onboarding-page/onboarding-page.component'

export const routes: Routes = [
    {
        path: '',
        canActivate: [isConfiguredGuard],
        component: FormPageComponent,
    },
    {
        path: 'onboarding',
        canActivate: [isNotConfiguredGuard],
        component: OnboardingPageComponent,
    },
    {
        path: 'no-connection',
        canActivate: [hasNoConnectionGuard],
        component: NoConnectionComponent,
    },
    {
        path: 'test',
        canActivate: [],
        component: TestComponent,
    },
]
